const login = {
  LOGIN_WELLCOME_TITLE: 'Agilidad y simpleza para el análisis financiero.',
  LOGIN_WELLCOME_SUBTITLE: 'Tené todo bajo control con Plika',
  //Login form
  LOGIN_FORM_TITLE: 'Iniciar sesión para comenzar',
  LOGIN_FORM_TITLE_CREATE_PASSWORD: 'Crear contraseña',
  LOGIN_FORM_INPUT_EMAIL_LABEL: 'Ingresá tu e-mail',
  LOGIN_FORM_INPUT_EMAIL_PLACEHOLDER: 'Ej. nombre@email.com',
  LOGIN_FORM_INPUT_EMAIL_CAPTION_EMPTY: 'Por favor, ingresá un e-mail',
  LOGIN_FORM_INPUT_EMAIL_CAPTION_FORMAT: 'Por favor, ingresá un e-mail válido',
  LOGIN_FORM_INPUT_EMAIL_CAPTION_NAME: 'Por favor ingrese su nombre',
  LOGIN_FORM_INPUT_EMAIL_CAPTION_SURNAME: 'Por favor ingrese su apellido',
  LOGIN_FORM_INPUT_EMAIL_CAPTION_OK: 'Formato de e-mail válido',
  LOGIN_FORM_INPUT_PASSWORD_LABEL: 'Ingresá tu contraseña',
  LOGIN_FORM_INPUT_PASSWORD_PLACEHOLDER: 'Contraseña',
  LOGIN_FORM_INPUT_A_PASSWORD_CAPTION_EMPTY:
    'Por favor, ingresá una contraseña',
  LOGIN_FORM_INPUT_PASSWORD_CAPTION_FORMAT:
    'Por favor, ingresá una contraseña válida',
  LOGIN_FORM_INPUT_PASSWORD_CAPTION_OK: 'Formato de contraseña válido',
  LOGIN_FORM_BUTTON_SUBMIT: 'Iniciar sesión',
  LOGIN_FORM_CONFIRM_PASSWORD_LABEL_CURRENT: 'Contraseña actual',
  LOGIN_FORM_CONFIRM_PASSWORD_LABEL_NEW: 'Contraseña nueva',
  LOGIN_FORM_CONFIRM_PASSWORD_CHARACTERS: 'Debe contener al menos 6 caracteres',
  LOGIN_FORM_CONFIRM_PASSWORD_RECONFIRM: 'Reconfirmar contraseña nueva',
  LOGIN_FORM_PASSWORD_NOT_SAME: 'Las contraseñas no coinciden',
  LOGIN_FORM_PASSWORD_NOT_DIFFERENT:
    'La contraseña debe ser distinta a la anterior',

  LOGIN_FEEDBACK_ERROR:
    'No reconocimos el e-mail o la contraseña que acabas de ingresar. Por favor, volve a intentar',

  LOGIN_FORGOT_PASSWORD_ACTION: 'Olvidé mi contraseña',
  LOGIN_GO_BACK_SESSION_ACTION: 'Volver a inicio de sesión',
  LOGIN_FORM_RESET_PASSWORD_TITLE: 'Restablecer contraseña',
  LOGIN_FORM_RESET_PASSWORD_NOTIFICATION_TEXT:
    'Te enviamos un mail para restablecer tu contraseña, por favor revisa tu casilla.',
  LOGIN_RESET_PASSWORD_FEEDBACK_SUCCESS_DESCRIPTION_1:
    'La constraseña se restableció con éxito. Ya puedes ',
  LOGIN_RESET_PASSWORD_FEEDBACK_SUCCESS_DESCRIPTION_2:
    ' con tu nueva contraseña.',
};

export default login;
